// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSuggestedProductsStyles } from "@bg/App/Widgets/ProductDetails/ProductDetailsSuggestedProducts";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productSuggestedProductsStyles.atcButton = {
    variant: "tertiary",
    css: css`
        &&& {
            position: relative;
            padding-left: 40px;
            @media (max-width: 481px) {
                max-width: 100%;
            }
            &&:hover ${IconWrapper} {
                color: ${getColor("common.white")};
            }
        }
        &.loading {
            ${IconWrapper} {
                display: none;
            }
            &,
            &:disabled {
                &,
                &:hover {
                    background: transparent !important;
                    border-color: ${getColor("text.main")} !important;
                    opacity: 1;
                }
            }
        }

        &&& ${IconWrapper} {
            position: absolute;
            left: 10px;
            top: 6px;
            height: 19px;
            width: 19px;
            transition: all 200ms ease-in-out;
            color: ${getColor("tertiary")};
        }
        &&&& svg {
            width: 19px !important;
            height: 19px !important;
        }
    `,
    icon: {
        src: "Cart",
        position: "left",
    },
};

productSuggestedProductsStyles.loadingSpinner = {
    color: "tertiary",
    size: 20,
};

productSuggestedProductsStyles.pdpLink = {
    css: css`
        margin-left: 5px;
        @media print {
            display: flex !important;
        }
        @media (max-width: 481px) {
            display: flex;
            flex-wrap: wrap;
        }
        color: ${getColor("text")} !important;
    `,
};
